import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { DocumentDraftTodoFormProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import DocumentCreateForm from "../../forms/createForm";
//#endregion

const DocumentDraftTodoSelectionForm: ForwardRefRenderFunction<FormHandles, DocumentDraftTodoFormProps> = (
  props,
  ref
) => {
  return <DocumentCreateForm {...props} ref={ref} isDocumentDraft />;
};

export default forwardRef(DocumentDraftTodoSelectionForm);
